export function isMiniProgramBaiduTemplate(row = {}) {
  return String(row.useTerminal || '').trim().toUpperCase() === 'MINI_PROGRAM'
    && String(row.templateType || '').trim().toUpperCase() === 'BAIDU_PUSH';
}

export function normalizeChannelConfigForm(input = {}) {
  const raw = input && typeof input === 'object' ? input : {};
  return {
    wecomAgentId: String(raw.wecomAgentId || '').trim(),
    wechatTemplateId: String(raw.wechatTemplateId || '').trim(),
    pagePath: String(raw.pagePath || 'pages/baidu-marketing/index').trim() || 'pages/baidu-marketing/index',
    wecomTitle: String(raw.wecomTitle || '百度线索提醒').trim() || '百度线索提醒',
    wecomSummary: String(raw.wecomSummary || '请尽快处理新线索').trim() || '请尽快处理新线索',
    fieldMappingVersion: String(raw.fieldMappingVersion || 'v1').trim() || 'v1'
  };
}

export function buildBindingStatusTag(binding = {}) {
  const status = String(binding.bindingStatus || 'PENDING').trim().toUpperCase();
  if (status === 'BOUND') return { type: 'success', text: '已绑定' };
  if (status === 'INVALID') return { type: 'danger', text: '已失效' };
  return { type: 'warning', text: '待绑定' };
}
